<!--Setting the CSS variable --appRowSizes here with [style.--appRowSizes] from config.
[style.--appRowSizes] = "this.layoutService.getAppLayoutHeights()"
Note 19. Jan 2024 -> not advisable to do it like this since it will execute getAppLayoutHeights() on every change detection cycle.
-->
@if (!stopProgram) {
  <div #appWrapper class = "appWrapper">
    <app-main-nav
      class = "mainNavComponent"
      (toggleTitle)='toggleTitle($event)'
      (selectedLang)='toggleText($event)'
      (openUserLayerSettingsEE)="setUserLayerSettingsData($event)"
      (updateSwitchApplication)="updateSwitchApplication($event)"
      [selText]="selText"
      [applicationName]="applicationName"
      [settings]="settings"
      [applicationSettings]="applicationSettings"
      [mapObject]="mapObject"
      [lang]="lang"
      [isMobileView]="isMobileView"
      [mapLayers] = "mapLayers"
      [apps]="apps$ | async"
    ></app-main-nav>
    @defer (when showDash) {
    <div id="subApp-dash" [innerHTML]="">
      <app-dash [selText]="selText" [settings]="settings" [lang]="lang" (bannerDismissedEE)="collapseDash()"></app-dash>
      </div>
    }
    <div id="map-wrapper">
      <app-map
        [selText]="selText"
        [lang]="lang"
        [mapLayers]="mapLayers"
        [settings]="settings"
        [applicationName]="applicationName"
        [applicationSettings]="applicationSettings"
        [(mapObject)]="mapObject"
        (updateMap)='updateMap($event)'
        [proxyLayers]="reloadLayersWithProxy"
        [isMobileView] = "isMobileView"
      ></app-map>
    </div>
    @defer (when layoutService.appLayoutSettings.footerHeight !== 0) {
      <div id="subApp-footer">
        <app-footer [selText]="selText"></app-footer>
      </div>
    }
    @defer (when uploadFilesActive) {
      <div class = "outerUploadWrapper">
        <app-upload-geo-files [selText]="selText"></app-upload-geo-files>
      </div>
    }
    @defer (when addLayerActive) {
      <div class = "outerUploadWrapper">
        <app-add-layer
          [applicationName] = "applicationName"
          [layerNameFromMainNav] = "userLayerName"
          [selText]="selText"
          (resetLayerName) = "resetInputForAddLayer()"
          (reloadMapviewEE) = "reloadMapview()"
        ></app-add-layer>
      </div>
    }
    @defer (when activateSwitchApplication) {
      <app-switch-application
        class = "switchApplicationComponent"
        [selText]="selText"
        [allApplications]="settings.applications"
        [currentApplication] = "applicationName"
        [currentURLSearchParams] = "initialURL"
        [apps]="apps$ | async"
        [activateSwitchApplication]="activateSwitchApplication"
        (updateSwitchApplication)="updateSwitchApplication($event)"
        >
      </app-switch-application>
    }
  </div>
}

@if (stopProgram && userNotInAllowedGroup) {
  <div>
    <app-notification-popup
      [paragraphs] = "[
      {text: selText.groupNoAccessHeader, style: {fontWeight: 'bold'}},
      {text: selText.groupNoAccessParagraph1},
      {text: selText.groupNoAccessParagraph2}
      ]"
      [selText] = "selText"
      (confirmed) = "userDeniedEntryComingBack()"
    ></app-notification-popup>
  </div>
}

@defer (when showLoginPrompt) {
  <div>
    <app-login-prompt [selText]="selText" [applicationSettings]="applicationSettings">
    </app-login-prompt>
  </div>
}
@defer (when selText.gdprConsent && applicationSettings?.option?.allowLogin && !cookieConsent) {
<div>
  <app-cookie-consent [selText]="selText" [applicationSettings]="applicationSettings" [lang]="lang">
  </app-cookie-consent>
</div>
}
@if (displayService.imageToShow$ | async; as imageURL) {
  <app-show-single-image
    [imageURL]="imageURL"
  >
  </app-show-single-image>
}